import type { ReactNode } from "react";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
  /** Hides the label visually, for a switch in a table row. */
  compact?: boolean;
}

export function Switch({ checked, onChange, label, description, disabled = false, compact = false }: SwitchProps) {
  const control = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={compact && typeof label === "string" ? label : undefined}
      className="switch"
      disabled={disabled}
      onClick={() => { onChange(!checked); }}
    >
      <span className="switch-thumb" />
    </button>
  );
  if (compact) return control;
  return (
    <label className="switch-row">
      <span className="switch-text">
        <span className="switch-label">{label}</span>
        {description === undefined ? null : <span className="switch-description">{description}</span>}
      </span>
      {control}
    </label>
  );
}
